import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useQuery } from 'src/hooks/useQuery'
import StockForm from '../../components/StockForm'
import StockTable from '../../components/StockTable'
import { actions } from '../../StockListState'
import * as S from './StockListPage.styles'

const StockListPage = () => {
  const dispatch = useDispatch()
  const query = useQuery()

  useEffect(() => {
    if (query.get('backFromProduct')) { return }
    dispatch(actions.clearStock())
  }, [dispatch, query])

  return (
    <S.Wrapper>
      <h1>Consulta do estoque</h1>
      <StockForm />
      <StockTable />
    </S.Wrapper>
  )
}

export default StockListPage
